import { render, staticRenderFns } from "./CompanyAdd.vue?vue&type=template&id=6db93794&scoped=true"
import script from "./CompanyAdd.vue?vue&type=script&lang=js"
export * from "./CompanyAdd.vue?vue&type=script&lang=js"
import style0 from "./CompanyAdd.vue?vue&type=style&index=0&id=6db93794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db93794",
  null
  
)

export default component.exports